<template>

  <main id="main" class="blog2">
 
     
    <!-- ======= Single Blog Section ======= -->
        <section class="hero-section inner-page blog">
            <div class="wave">
                <svg width="1920px" height="265px" viewBox="0 0 1920 265" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <g id="Apple-TV" transform="translate(0.000000, -402.000000)" fill="#FFFFFF">
                            <path d="M0,439.134243 C175.04074,464.89273 327.944386,477.771974 458.710937,477.771974 C654.860765,477.771974 870.645295,442.632362 1205.9828,410.192501 C1429.54114,388.565926 1667.54687,411.092417 1920,477.771974 L1920,667 L1017.15166,667 L0,667 L0,439.134243 Z" id="Path"></path>
                        </g>
                    </g>
                </svg>
            </div>
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-12">
                        <div class="row justify-content-center">
                            <div class="col-md-10 text-center hero-text">
                                <h1 data-aos="fade-up" data-aos-delay="">Getting Started
                                </h1>
                                <h4 data-aos="fade-up" data-aos-delay="">Secure your API key by moving it to our relay server</h4>
                                <p class="mb-5" data-aos="fade-up" data-aos-delay="100">
                                    &bullet;
                                     By <a href="#" class="text-white">Andreas Braumann</a></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="site-section mb-4 mt-5">
            <div class="container">
                <div class="row">
                    <div class="col-md-8 blog-content">
                        <h3>Using hideAPIkey.com</h3>
                        <p>We will be using Postman for explaining how to secure your API key</p>
                        
                        <div class="row mb-5">
                            <div class="col-md-6">
                                <figure><img src="/img/blog/keys.jpg" class="img-fluid">
                                </figure>
                            </div>
                            <div class="col-md-6">
                                <!-- <figure><img src="/img/blog/keys.jpg" class="img-fluid">
                                </figure> -->
                            </div>
                        </div>
                        <div>
                            <ol>
                                <li>You can use one of our predefined APIs by selecting it. Continue with step 5.</li>
                                <li>If you want to use another API please discover the field name and the value of your API key. Typically the field name is called X-API-KEY and the the key consists of alphanumeric characters.
                                </li>
                                <li>Fill in your Header Key.
                                </li>
                                <li>Be sure to select the correct HTTP verb for the API and the correct method of injecting the API key in the request.</li>
                                <li>Enter your e-mail and API Key value and click the "Hide API key" button</li>
                                <li>Your unique relay URL will be shown immediately. You will also receive a confirmation e-mail for your reference.</li>
                                <li>Prepend your original API URI with the relay URL. If your original API URI was <code>https://api.something.com/api/v1/dosomething</code> it should now read <br><code>https://api.hideapi.key/123-123-12/https://api.comething.com/api/v1/dosomething.</code> hideAPIkey.com 
                                supports different HTTP verbs like POST, GET, ... and also different methods of injecting the API key in the request. You can choose between header, form-data and query.
                                </li>
                                <li>Finally remove the API key from your request. hideAPIkey.com forwards all data sent to your custom relay endpoint and adds your previously entered key in the request.
                                </li>
                            </ol>
                        </div>
                        <!-- <div class="pt-5">
                            <p>Categories: <a href="#">Design</a>, <a href="#">Events</a> Tags: <a href="#">#html</a>, <a href="#">#trends</a></p>
                        </div> -->
                    </div>
                    <!--<div class="col-md-4 sidebar">
                        <div class="sidebar-box pt-0">
                            <h3><ph</h3>
                            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ducimus itaque, autem necessitatibus voluptate quod mollitia delectus aut, sunt placeat nam vero culpa sapiente consectetur similique, inventore eos fugit cupiditate numquam!</p>
                        </div>
                        <div class="sidebar-box pt-0">
                            <img src="/img/andreas_braumann.png" alt="Image placeholder" class="img-fluid mb-4 shadow author">
                            <h3>About The Author</h3>
                            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ducimus itaque, autem necessitatibus voluptate quod mollitia delectus aut, sunt placeat nam vero culpa sapiente consectetur similique, inventore eos fugit cupiditate numquam!</p>
                        </div>
                    </div>-->
                </div>
            </div>
        </section>
        <!-- ======= CTA Section ======= -->
        <section class="section cta-section">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-md-6 mr-auto text-center text-md-left mb-5 mb-md-0">
                        <h2 class="mb-0">Interested in API key security?</h2>
                    </div>
                    <div class="col-md-5 text-center text-md-right">
                        <form action="">
                            <div class="news-letter">
                                <input type="email" placeholder="Enter Your Email">
                                <button> <span class="height-0 icon la la-angle-right"></span></button>
                            </div>
                        </form>
                        <p class="text-white mb-0">Sign up for our hideAPIkey.com newsletter and security related information for your front-end.
                        </p>
                    </div>
                </div>
            </div>
            
        </section><!-- End CTA Section -->
  </main>
</template>
<script>
import HideApiKeyWidget from "../components/HideApiKeyWidget.vue";
import attachBanner from "../../node_modules/@beyonk/gdpr-cookie-consent-banner/dist/esm/bundle.js";
import { BAvatar } from "bootstrap-vue/esm/components/avatar/avatar";

export default {
  name: "home",
  components: {
    HideApiKeyWidget,
    BAvatar,
  },
  mounted() {
    const options = {
      /**
       * You must set the cookie name.
       **/
      cookieName: "hideapikey_gdpr",

      /**
       * The cookie configuration, such as domain and path.
       **/
      cookieConfig: {
        domain: "hideapikey.com",
        path: "/",
      },

      /**
       * These are the top two lines of text on the banner
       * The 'description' field can include html such as links
       **/
      heading: "GDPR Notice",
      description:
        'We use cookies to offer a better browsing experience, analyze site traffic, personalize content, and serve targeted advertisements. Please review our <a href="/privacy-policy">privacy policy page</a>. By clicking accept, you consent to our privacy policy & use of cookies.',

      /**
       * All the button labels
       **/
      acceptLabel: "Accept",
      settingsLabel: "Preferences",
      closeLabel: "Close window",

      /**
       * These are the default opt-ins and their descriptions.
       * When value is set to true, the option will automatically be checked on load.
       *
       * If you don't want to show a category, simply remove the specified key from this object.
       **/
      choices: {
        necessary: {
          label: "Required cookies",
          description:
            "These can't be turned off as they are used to control all the other cookies",
          value: true,
        },
        analytics: false,
      },

      /**
       * Show an icon to edit cookies later, when banner is closed.
       **/
      showEditIcon: true,

      /**
       * These are the functions which are run if a user opts-in to that category.
       * You should drop your cookies here (or set a variable to control the later dropping of cookies.
       *
       * If you are using svelte, you can use events instead - see the Svelte section below.
       **/
      categories: {
        tracking: function () {
          let themejs = document.createElement("script");
          themejs.setAttribute(
            "src",
            "https://www.googletagmanager.com/gtag/js?id=G-Z1K6RVY03J"
          );
          document.head.appendChild(themejs);

          window.dataLayer = window.dataLayer || [];
          function gtag() {
            dataLayer.push(arguments);
          }
          gtag("js", new Date());

          gtag("config", "G-Z1K6RVY03J");
        },
        marketing: function () {},
        necessary: function () {},
      },
    };
    attachBanner(this.$refs.gdprBanner, options);
  },
};
</script>
<style scoped>
@import "../../node_modules/@beyonk/gdpr-cookie-consent-banner/dist/style.css";

@import "../plugins/icofont/icofont.min.css";
@import "../plugins/line-awesome/css/line-awesome.min.css";
@import "../plugins/owl.carousel/assets/owl.carousel.min.css"; 

@import "../../node_modules/vue-mailchimp-email-signup-form/dist/vue-mailchimp-email-signup-form.css";

</style>